
function wishlistCount(str){
  var search = str.match(/jms-wishlist-/g);
  if(search == null) return 0;
  else return search.length;
}
function jmsToLoginPage(){
  jmsWishlistCreateMessage('Please <a href="/account/login/">Login</a> to use this function', 'alert',5000);
}
function jmsWishlistDestroyMessage(xbtn, timeoutid){
  var mess = xbtn.parentNode;
  mess.style.opacity = 0;
  if(timeoutid != undefined){
    setTimeout(function(){document.body.removeChild(mess);},500);
  }
}
function jmsWishlistCreateMessage(str, type, time){
  var mess = document.createElement('div');
  mess.setAttribute('class', 'jms-wishlist-message');
  if(type == 'error'){
    mess.style.backgroundColor = '#f44336';
  }
  else{
    mess.style.backgroundColor = '#4CAF50';
  }
  var xbtn = document.createElement('div');
  xbtn.setAttribute('class', 'closebtn');
  xbtn.setAttribute('onclick','jmsWishlistDestroyMessage(this)');
  xbtn.innerHTML = '&times;';
  mess.innerHTML = str;
  mess.appendChild(xbtn);
  document.body.appendChild(mess);
  mess.style.left = ((window.innerWidth - mess.clientWidth)/2)+'px';
  var timeoutid = setTimeout(function(){jmsWishlistDestroyMessage(xbtn, timeoutid);}, time);
}

function jmsWishlistAddTag(handle,div){
  var button = document.getElementById('add-wishlist-button-'+handle);
  var cus_id = document.getElementById('jms-wishlist-cus-id').getAttribute('content');
  button.className = 'fa fa-spinner fa-pulse';
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function(){
      if(this.readyState == 4 && this.status == 200){
        if(xhttp.responseText == 4){
          jmsWishlistCreateMessage('Your Wishlist is full','error',1500);
          button.className='fa fa-heart-o';
        }
        else{
          jmsWishlistCreateMessage('Product added to Wishlist','success',1500);
          button.className = 'fa fa-check';
          div.onclick = "";
          div.style = "cursor:auto";
          var counts = document.getElementsByClassName('jms-wishlist-count');
          if(counts.length == 0){
            var number = document.getElementsByClassName('jms-wishlist-number');
            for(var i=0; i<number.length; i++){
              number[i].innerHTML = '<span class="jms-wishlist-count">1</span>';
            }
          }
          else{
            for(var i = 0; i< counts.length; i++){

               counts[i].innerHTML = Number(counts[i].innerHTML)+1;
            }
          }
        }
      }
    }
    xhttp.open('POST','/apps/jms-wishlist',true);
    xhttp.setRequestHeader('Content-Type','application/x-www-form-urlencoded')
     xhttp.send('function=add&method=PUT&url=/admin/customers/'+cus_id+'.json&param='+handle);
}
function jmsWishlistDeleteTag(handle){
  var cus_id = document.getElementById('jms-wishlist-cus-id').getAttribute('content');
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function(){
    if(this.readyState == 4 && this.status == 200){
      location.reload();
    }
  }
    xhttp.open('POST','/apps/jms-wishlist',true);
    xhttp.setRequestHeader('Content-Type','application/x-www-form-urlencoded')
    xhttp.send('function=delete&method=PUT&url=/admin/customers/'+cus_id+'.json&param='+handle);
}
function jmswlSendAddTag(handle){
  var cus_id = document.getElementById('jms-wishlist-cus-id').getAttribute('content');
  var form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', '/apps/jms-wishlist');
  var funct = document.createElement('input');
  funct.setAttribute('value', 'add');
  funct.setAttribute('name', 'function');
  var url = document.createElement('input');
  url.setAttribute('value', '/admin/customers/'+cus_id+'.json');
  url.setAttribute('name', 'url');
  var method = document.createElement('input');
  method.setAttribute('value', 'PUT');
  method.setAttribute('name', 'method');
  var ajax = document.createElement('input');
  ajax.setAttribute('value', '1');
  ajax.setAttribute('name', 'ajax');
  var param = document.createElement('input');
  param.setAttribute('value', handle);
  param.setAttribute('name', 'param');
  form.appendChild(funct);
  form.appendChild(url);
  form.appendChild(method);
  form.appendChild(ajax);
  form.appendChild(param);
  document.body.appendChild(form);
  form.submit();
}
